import NavBar from "@public-sites/unified-header/dist/src/index";
import "@public-sites/unified-header/styles.css";
import Prefetch from "./prefetch";

export interface SharedNavBarProps extends React.ComponentProps<typeof NavBar> {}

const SharedNavBar: React.FC<SharedNavBarProps> = props => {
	return (
		<>
			<Prefetch {...props} />
			<NavBar {...props} />
		</>
	);
};

export default SharedNavBar;
